export default __webpack_public_path__ + "static/media/98.26a3cb4a.jpg";